export default __webpack_public_path__ + "static/media/pro-elevate-blk-banner-1.2be63b7d.jpg";